import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import { Subject, from, EMPTY } from 'rxjs';
import { ref, onUnmounted, reactive, computed, onMounted } from 'vue';
import { Form, notification } from "ant-design-vue";
import { catchError, switchMap, throttleTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { useIdentityStore } from '@/stores/useIdentityStore';
import { useRouter } from 'vue-router';


const useForm = Form.useForm;
export default function useDefault() {
    const store = useIdentityStore();
    const router = useRouter();
    const currentUser = computed(() => store.currentUser);


    const defaultOrderBy = 'Stamp';
    const defaultDirection = 'Desc';

    const params = reactive({
        pageIndex: 1,
        pageSize: 3,
        fileType:2,
        orderBy: defaultOrderBy,
        direction: defaultDirection,
    });

    const newsList = ref([]);
    const topList = ref([]);
    //获取新闻列表
    const getNews$ = new Subject();
    const getNewsSubscription = getNews$.pipe(
        switchMap((request) => http.get(Uris.List, request))
    ).subscribe(result => {
        if (result.list && result.list.length > 0) {

            const resultList = result.list.map(element => {
                const model = {
                    id: element.id,
                    title: element.title,
                    month: dayjs(element.stamp).format('MM'),
                    day: dayjs(element.stamp).format('DD'),
                    stamp: dayjs(element.stamp).format('YYYY年MM月DD日'),
                    intro: element.intro,
                    publisher: element.publisher,
                    cardImage: `${window.serverConfig.baseUrl}/${element.cardImage}`,
                    categoryName:element.categoryName,
                };
                return model;
            });

            // 第一条数据保存到 topList
            topList.value = [resultList[0]];
            // 剩下的数据保存到 newsList（从索引1开始取最多2条）
            newsList.value = resultList.slice(1, 3);
        } else {
            // 如果没有数据，清空两个列表
            topList.value = [];
            newsList.value = [];
        }
    });

    ///获取首页新闻
    const getNewsList = () => {
        params.pageIndex = 1;
        params.pageSize = 3;
        getNews$.next(params);
    };


    const resourceList = ref([]);
        //获取列表
        const getResource$ = new Subject();
        const getResourceSubscription = getResource$.pipe(
            switchMap((request) => http.get(Uris.ResourceList, request))
        ).subscribe(result => {
             if (result.list && result.list.length > 0) {

            const resultList = result.list.map(element => {
                const model = {
                    id: element.id,
                    title: element.title,
                    
                    coverImage: `${window.serverConfig.baseUrl}/${element.coverImage}`,
                };
                return model;
            });
             resourceList.value = resultList;
        }
        
    
        });
    
    const getResourceList = () => {
        params.fileType= 2, 
        params.pageIndex = 1;
        params.pageSize = 3;
        getResource$.next(params);
    };

    onUnmounted(() => {
        getNewsSubscription.unsubscribe();
        getResourceSubscription.unsubscribe();
    });

    return {
        getNewsList,
        newsList,
        topList,
        getResourceList,
        resourceList
    };
}